import React, { useState, useEffect } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  ListGroup,
  Card,
  Badge,
} from "react-bootstrap";
import Alert from "react-bootstrap/Alert";
import { useSelector } from "react-redux";
import "./style.css";
import Api from "../api/Api";
import TimeAgo from "../timeAgo/TimeAgo";
import Avatar from "../notes/Avatar";
import { Link } from "react-router-dom";
import axios from "axios";
import Spinner from "../../../components/common/spinner/Spinner";
import AllMessage from "../../../components/common/allMessage/AllMessage";

const Notification = () => {
  const [showModal, setShowModal] = useState(false);
  const [selectedNotification, setSelectedNotification] = useState(null);
  const loggedInUser = useSelector((state) => state.auth.user);
  const userId = loggedInUser?.user?.id;
  const token = loggedInUser?.refreshToken;
  const [data, setData] = useState([]); 
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const [isLoading, setIsLoading] = useState(false);
  const notificationApi = Api({
    url: `notify/all/user/${userId}`,
  });
  useEffect(() => {
    setIsLoading(true);
    const fetchPropertyData = async () => {
      try {
        const data = {
          page_number: 1,
          page_size: 20,
          order_by: "ASC",
        }; 
        const responseData = await notificationApi.postData(data);
        console.log(responseData);
        setData(responseData.data.notifications);
        setIsLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchPropertyData();
  }, []);
  const handleViewDetails = (notification) => {
    setSelectedNotification(notification);
    setShowModal(true);
  };
  const markNotificationAsRead = async (notificationId) => {
    try {
      const formData = new FormData();
      formData.append("isRead", true);
      formData.append("notificationId", notificationId);

      await axios.put(`${baseUrl}/notify/setRead`, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });

      setData(
        data.map((notification) =>
          notification.id === notificationId
            ? { ...notification, is_read: true }
            : notification
        )
      );
    } catch (error) {
      console.error("Error marking notification as read:", error);
    }
  };
  // notify/getCount
  const handleCardClick = async (notificationId) => {
   
    if (
      !data.find((notification) => notification.id === notificationId).is_read
    ) {
      await markNotificationAsRead(notificationId);
    }
  };
  return (
    <Container>
      {isLoading ? (
        <Spinner />
      ) : (
        <>
          <Row className="mt-4 mb-3">
            <Col md={12}>
              <div className="d-flex align-items-center gap-2">
                <span className="fs-4 text-warning">🔔</span>
                <h2 className="mb-0 fw-semibold text-dark-emphasis" style={{ letterSpacing: "0.5px" }}>
                  All Notifications
                </h2>
              </div>
              <hr className="mt-2" />
            </Col>
          </Row>

          {data?.length === 0 ? (
            // <h1>No notifications found.</h1> 
            <AllMessage title={"No notifications found."} />
          ) : (
            <>

<Row className="notification-page">
  {data.map((notification) => {
    const isUnread = !notification.is_read;

    return (
      <Col md={12} key={notification.id}>
        <div className={`notif-card ${isUnread ? "notif-unread" : "notif-read"}`}>
          {/* Left indicator */}
          <div className="notif-strip"></div>

          {/* Avatar + Content */}
          <div className="notif-body">
            <div className="d-flex align-items-start gap-3">
              <Avatar
                src={false}
                icon={notification.user_name}
                size={48}
                style={{ fontSize: "1.1rem" }}
              />

              <div className="w-100">
                <div className="d-flex justify-content-between align-items-start">
                  <div>
                    <h6 className="notif-title mb-1">{notification.notification_title}</h6>
                    <div className="d-flex gap-2 align-items-center mb-2">
                      <Badge bg="secondary" className="text-uppercase small">
                        {notification.notification_for}
                      </Badge>
                      {isUnread && (
                        <Badge bg="warning" text="dark" className="small">
                          Unread
                        </Badge>
                      )}
                    </div>
                  </div>

                  <Link
                    to={`/notification/${notification.id}`}
                    onClick={() => handleCardClick(notification.id)}
                    className={`btn btn-sm ${
                      isUnread ? "btn-primary" : "btn-outline-primary"
                    }`}
                  >
                    View
                  </Link>
                </div>

                <p className="notif-text">
                  {notification.notification_text.length > 80
                    ? `${notification.notification_text.slice(0, 80)}...`
                    : notification.notification_text}
                </p>

                <div className="notif-meta">
                  By <b>{notification.user_name}</b> | {notification.user_type} ·{" "}
                  <TimeAgo timestamp={notification.created_on} />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Col>
    );
  })}
</Row>




            </>
          )}
        </>
      )}
    </Container>
  );
};

export default Notification;
